import React, { memo } from 'react';

const LoadingIndicator = ({ show, label = 'Loading...' }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="absolute inset-0 z-30 flex items-center justify-center bg-gray-900 bg-opacity-80">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
        <p className="text-white text-sm opacity-70">{label}</p>
      </div>
    </div>
  );
};

export default memo(LoadingIndicator);
